import { render, staticRenderFns } from "./SpouseWorkingData.vue?vue&type=template&id=c47eb92e&"
import script from "./SpouseWorkingData.vue?vue&type=script&lang=js&"
export * from "./SpouseWorkingData.vue?vue&type=script&lang=js&"
import style0 from "./SpouseWorkingData.vue?vue&type=style&index=0&id=c47eb92e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports